import { Box, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import * as React from "react";
import { useRecoilValue } from "recoil";

import { PropertyEditCurrentValue } from "@/components/property_edit/PropertyEditHistoryRow";
import { PropertyEditLayout as BaseTemplate } from "@/components/property_edit/PropertyEditLayout";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { InsuranceInfoHistoryEditor } from "./HistoryEditor";
import { InsuranceInfoHistoryItem } from "./HistoryItem";
import { InsuranceType } from "./types";

interface props {
  insuranceType: InsuranceType;
  onClickPageBack: () => void;
}

export const EditPropertySectionInsuranceInfoHistory: React.FC<props> = ({ insuranceType, onClickPageBack }) => {
  // 選択済み物件取得
  const selected_property = useRecoilValue(SelectedProperty);
  const [recordVersion, setRecordVersion] = React.useState(0);
  const handleOnCreate = () => setRecordVersion((version) => version + 1);

  const getInsuranceCostByType = (insuranceType: InsuranceType, data: any) => {
    switch (insuranceType) {
      case "火災保険":
        return data.fire_insurance_cost;
      case "地震保険":
        return data.earthquake_insurance_cost;
      default:
        return undefined;
    }
  };

  const filteredAndSortedResults =
    selected_property?.user_input_monthly_cashflow_results
      ?.filter((result) => {
        const cost = getInsuranceCostByType(insuranceType, result);
        return cost !== undefined && cost !== null;
      })
      .sort((a, b) => new Date(b.month).getTime() - new Date(a.month).getTime()) || [];

  // 最新のデータ（最初の1件）と過去のデータ（2件目以降）を分離
  const latestResult = filteredAndSortedResults[0];

  return (
    <BaseTemplate headerTitle={insuranceType} onBack={onClickPageBack} backLabel="保険" isBackGroundWhite>
      <PropertyEditCurrentValue
        value={
          latestResult
            ? `${Number(getInsuranceCostByType(insuranceType, latestResult)).toLocaleString()}${"円"}`
            : "未登録"
        }
        since={latestResult ? dayjs(latestResult.month).format("YYYY年M月") : undefined}
      />
      <Typography component="h3" data-edit-section>
        更新した保険を記録する
      </Typography>
      {
        <InsuranceInfoHistoryEditor
          key={recordVersion}
          insuranceType={insuranceType}
          onCancel={onClickPageBack}
          onCreate={handleOnCreate}
          propertyHolder={selected_property}
        />
      }
      <Box mt={4}>
        <Typography component="h3" data-edit-section>
          これまでの保険
        </Typography>
        {filteredAndSortedResults.map((result) => (
          <InsuranceInfoHistoryItem
            key={result.month}
            monthlyCashflowResult={result}
            insuranceType={insuranceType}
            propertyHolder={selected_property}
          />
        ))}
        <Typography variant="body2" color="textSecondary">
          行をタップすると、記録を訂正したり削除したりできます。
        </Typography>
      </Box>
    </BaseTemplate>
  );
};
